import { Box, Typography, useTheme } from '@mui/material'
import BackIconButton from 'components/atoms/button/BackIconButton'
import NextIconButton from 'components/atoms/button/NextIconButton'
import NavStepper from 'components/atoms/NavStepper'
import ToolTipCustomized from 'components/atoms/container/ToolTipCustomized'
import { useTranslation } from 'react-i18next'

const StepPathNavStepper = ({
  length,
  activeStep,
  firstL2Step,
  size = 48,
  iconSize = 24,
  handlePrevious,
  handleNext,
  conatinerSx = {},
  nextIconTestId = 'ArrowForwardIcon',
  backIconTestId = 'ArrowBackIcon',
  disableNextForRoleplay = false
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const navBtnSx = {
    minWidth: size,
    height: size,
    borderRadius: 25,
    padding: 0,
    '& .MuiSvgIcon-root': {
      fontSize: iconSize
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        padding: '8px 12px !important',
        marginTop: 'auto',
        ...conatinerSx
      }}>
      <NavStepper
        length={length}
        activeStep={activeStep}
        backButton={
          <BackIconButton
            sx={navBtnSx}
            disabled={activeStep === 0 && firstL2Step}
            onClick={() => handlePrevious()}
            dataTestId={backIconTestId}
          />
        }
        nextButton={
          <ToolTipCustomized
            placement='top'
            toolTip={
              disableNextForRoleplay && (
                <Typography
                  variant='body1Small'
                  sx={{
                    display: 'flex',
                    fontWeight: 600,
                    textAlign: 'center'
                  }}>
                  {t('rolePlay.completeARolePlaySession')}
                </Typography>
              )
            }>
            <span>
              <NextIconButton
                sx={navBtnSx}
                onClick={() => handleNext()}
                disabled={disableNextForRoleplay}
                dataTestId={nextIconTestId}
              />
            </span>
          </ToolTipCustomized>
        }
      />
    </Box>
  )
}
export default StepPathNavStepper
